import React from 'react';

// Shown at the top of an Add/Edit form when it was opened via a row's
// Duplicate action (identified by the `_duplicateSourceId` a form's caller
// stamps onto the pre-filled record — same convention across every screen's
// kebab Duplicate, e.g. ProductTable.js/PriceTable.js), so the
// user doesn't mistake the pre-filled copy for the original record.
function DuplicateBanner({ label }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 14,
        padding: '14px 20px',
        marginBottom: 18,
        background: '#fff',
        border: '1px solid #e3e7ee',
        borderBottom: '3px solid #1976d2',
        borderRadius: 8,
      }}
    >
      <span
        style={{
          flexShrink: 0,
          width: 26,
          height: 26,
          borderRadius: '50%',
          background: '#d92d20',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          fontSize: 15,
        }}
      >
        !
      </span>
      <div>
        <div style={{ fontWeight: 700, fontSize: 16 }}>This is a copy</div>
        <div style={{ marginTop: 4, fontSize: 14, color: '#333' }}>
          This is a copy of a {label}. Revise as needed and save the {label}.
        </div>
      </div>
    </div>
  );
}

export default DuplicateBanner;
